<template>
  <div class="print-dialog">
    <base-button class="mb-2" size="sm" type="primary">Print </base-button>
    <div id="invoice">
      <div style="text-align:center;">
        <h3>Quote</h3>
      </div>
      <div class="grid-container">
        <div class="grid-row header-column">
          <div class="grid-item column-1">
            <strong>Rajput Electricals(20-21)</strong>
            <br />Company's GSTIN/UIN :
            <strong>27AEEPR1809Q1ZY</strong>
          </div>
          <div class="grid-item column-2">
            <div class="meta">
              <span>Sr No:</span>
              <span>{{ receipt.invoiceNumber }}</span>
            </div>
            <div class="meta">
              <span>Supplier's Ref:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Delivery Note:</span>
              <span>--</span>
            </div>
          </div>
          <div class="grid-item column-3">
            <div class="meta">
              <span>Dated:</span>
              <span>{{ receipt.date | dateFormat }}</span>
            </div>
            <div class="meta">
              <span>Other References:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Mode/Terms of Payment:</span>
              <span>{{ receipt.paymentModeName }}</span>
            </div>
          </div>
        </div>
        <div class="grid-row header-column">
          <div class="grid-item column-1">
            Buyer -
            <span v-if="receipt.userData && receipt.userData.firstName"
              >{{ receipt.userData.firstName | capitalize }}
              {{ receipt.userData.lastName | capitalize }}</span
            >
            <br />
            <br />State Name - Maharashtra Code :27
            <br />
          </div>
          <div class="grid-item column-2">
            <div class="meta">
              <span>Buyer's Order No:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Dispatch Document No:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Dispatched Through:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Job No:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Vendor Name:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Terms Of Delivery:</span>
              <span>--</span>
            </div>
          </div>
          <div class="grid-item column-3">
            <div class="meta">
              <span>Dated:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Delivery Note Date:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Designation:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Purchase Order No:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Received By:</span>
              <span>--</span>
            </div>
            <div class="meta">
              <span>Vehicle No:</span>
              <span>--</span>
            </div>
          </div>
        </div>
        <div class="grid-row header-column-products">
          <div class="grid-item">#</div>
          <div class="grid-item">Description of Goods</div>
          <div class="grid-item">HSN/SAC</div>
          <div class="grid-item">GST</div>
          <div class="grid-item">Qty</div>
          <div class="grid-item">Rate</div>
          <div class="grid-item">Per</div>
          <div class="grid-item">Disc %</div>
          <div class="grid-item">Amount</div>
        </div>
        <div
          v-for="(item, index) in receipt.productList"
          :key="index + `_productsRow`"
          class="grid-row product-list"
        >
          <div class="grid-item">{{ index + 1 }}</div>
          <div class="grid-item">{{ item.name }}</div>
          <div class="grid-item">{{ item.hsn }}</div>
          <div class="grid-item">{{ item.gstRate }} %</div>
          <div class="grid-item">{{ item.quantity }}</div>
          <div class="grid-item">{{ item.rate }}</div>
          <div class="grid-item">{{ item.per }}</div>
          <div class="grid-item">{{ item.discount }} %</div>
          <div class="grid-item">{{ item.amount }}</div>
        </div>
        <div
          v-for="index in maximumProducts - receipt.productList.length"
          :key="index + `_emptyRows`"
          class="grid-row product-list"
        >
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
        </div>
        <div class="grid-row cgst">
          <div class="grid-item" />
          <div class="grid-item">CGST</div>
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" style="border-right:none">
            {{ receipt.cgst }}
          </div>
        </div>
        <div class="grid-row sgst">
          <div class="grid-item" />
          <div class="grid-item">SGST</div>
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" style="border-right:none">
            {{ receipt.sgst }}
          </div>
        </div>
        <div class="grid-row round-off">
          <div class="grid-item" />
          <div class="grid-item">Round Off</div>
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" style="border-right:none">
            {{ receipt.roundOff }}
          </div>
        </div>
        <div class="grid-row total">
          <div class="grid-item" />
          <div class="grid-item">Total</div>
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" />
          <div class="grid-item" style="border-right:none">
            Rs. {{ receipt.finalTotal }}
          </div>
        </div>
        <div class="grid-row footer-row">
          <div class="grid-row note">
            <div class="grid-item first-note">Amount Chargable (in words)</div>
            <div class="grid-item second-note">E & O E</div>
          </div>
          <div class="grid-row amount-in-words">
            <div class="grid-item">INR {{ receipt.amountInWords }}</div>
          </div>
          <div class="grid-row note">
            <div class="grid-item">
              <div class="gst-details">
                <div>
                  <span>Company's GSTIN/UIN:</span>
                  <span>27AEEPR1809Q1ZY</span>
                </div>
              </div>
            </div>
            <div class="grid-item">
              <span>Company's Bank Details</span>
              <div class="grid-row company-details">
                <div class="grid-item">
                  <span>Bank Name:</span>
                  <span>Central Bank of India</span>
                </div>
                <div class="grid-item">
                  <span>A/c No:</span>
                  <span>3065957826</span>
                </div>
                <div class="grid-item">
                  <span>Branch & IFSC Code:</span>
                  <span>Aundh Road & CBIN0283483</span>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-row last-row">
            <div class="declaration">
              <span
                >We declare that this invoice shows the actual price of the
                goods described and that all particulars are true and
                correct</span
              >
            </div>
            <div class="signature" />
          </div>
        </div>
      </div>
      <div style="text-align:center;">
        <h5>This is a Computer Generated Invoice</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dateFns from "date-fns";
export default {
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    dateFormat(value) {
      return dateFns.format(new Date(value), "Do MMM YYYY");
    }
  },
  data: () => {
    return {
      maximumProducts: 100
    };
  },
  computed: {
    ...mapGetters({ receipt: "sale/getReceiptData" })
  },
  methods: {
    makeRowTotal(item) {
      const discountInRupee =
        parseFloat(item.price) *
        parseInt(item.quantity) *
        (parseFloat(item.discount) / 100);
      return parseFloat(item.price) * parseInt(item.quantity) - discountInRupee;
    },
    printPDF() {
      try {
        const pdfWindow = window.open("", "PRINT", "height=400,width=600");
        pdfWindow.document.write(
          "<html><head><title>" + document.title + "</title>"
        );
        pdfWindow.document.write(
          "<style>.grid-container{background-color:#2196f3;font-family:arial;font-size:12px;width:680px;min-height:250mm;display:flex;flex-direction:column;background:#fff;border:1px solid rgba(0,0,0,.8);position:relative}.grid-container .grid-row{display:grid}.grid-item{padding:5px}.header-column{grid-template-columns:50% 25% 25%;border-bottom:1px solid #000}.grid-item.column-1{border-right:1px solid #000}.grid-item.column-2{border-right:1px solid #000;display:grid;grid-template-columns:100%;padding:0}.grid-item.column-3{display:grid;grid-template-columns:100%;padding:0}.header-column-products{grid-template-columns:.4fr 3fr 1fr .7fr .5fr 1fr .5fr 1fr 1fr;font-weight:700}.total{grid-template-columns:.4fr 3fr 1fr .7fr .5fr 1fr .5fr 1fr 1fr;flex-grow:1}.cgst{grid-template-columns:.4fr 3fr 1fr .7fr .5fr 1fr .5fr 1fr 1fr;text-align:end;font-style:italic}.cgst .grid-item{border-right:1px solid #000}.sgst{grid-template-columns:.4fr 3fr 1fr .7fr .5fr 1fr .5fr 1fr 1fr;text-align:end;font-style:italic}.sgst .grid-item{border-right:1px solid #000}.round-off{grid-template-columns:.4fr 3fr 1fr .7fr .5fr 1fr .5fr 1fr 1fr;text-align:end;font-style:italic}.round-off .grid-item{border-right:1px solid #000}.total .grid-item{border-right:1px solid #000;border-bottom:1px solid #000;border-top:1px solid #000}.bottom-border{border-bottom:1px solid #000}.product-list{grid-template-columns:.4fr 3fr 1fr .7fr .5fr 1fr .5fr 1fr 1fr}.header-column-products .grid-item{border-right:1px solid #000;border-bottom:1px solid #000}.header-column-products .grid-item:last-child{border-right:none}.product-list .grid-item{border-right:1px solid #000;min-height:25px;padding-bottom:0;max-height:25px}.product-list .grid-item:last-child{border-right:none}.grid-row.note{grid-template-columns:50% 50%}.second-note{text-align:right}.gst-details{align-items:flex-end;display:flex;height:100%}.grid-row .last-row{grid-template-columns:50% 50%}.last-row .signature{display:flex;height:100%;border-top:1px solid #000;border-left:1px solid #000}.last-row .declaration{padding:5px}.company-details .grid-item{display:grid;grid-template-columns:42% 58%;padding:0}.company-details .grid-item span:last-child{font-weight:700}.amount-in-words{padding-top:none;font-weight:700}.grid-item .meta{display:grid;border-bottom:1px solid #000;padding-left:5px}.grid-item .meta:last-child{border-bottom:none}</style></head><body>"
        );
        pdfWindow.document.write("<div id='invoice'>");
        pdfWindow.document.write(document.getElementById("invoice").innerHTML);
        pdfWindow.document.write("</div></body></html>");
        pdfWindow.print();
        return true;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.grid-container {
  background-color: #2196f3;
  font-family: "arial";
  font-size: 12px;
  /* margin: 0 auto; */
  width: 100%;
  min-height: 250mm;
  /* max-height: 292mm; */
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.8);
  position: relative;
}
.grid-container .grid-row {
  display: grid;
}

.grid-item {
  padding: 5px;
}

.header-column {
  grid-template-columns: 50% 25% 25%;
  border-bottom: 1px solid black;
}
.grid-item.column-1 {
  border-right: 1px solid black;
}
.grid-item.column-2 {
  border-right: 1px solid black;
  display: grid;
  grid-template-columns: 100%;
  padding: 0;
}

.grid-item.column-3 {
  display: grid;
  grid-template-columns: 100%;
  padding: 0;
}

.header-column-products {
  grid-template-columns: 0.4fr 3fr 1fr 0.7fr 0.5fr 1fr 0.5fr 1fr 1fr;
  font-weight: bold;
}

.total {
  grid-template-columns: 0.4fr 3fr 1fr 0.7fr 0.5fr 1fr 0.5fr 1fr 1fr;
  flex-grow: 1;
}

.cgst {
  grid-template-columns: 0.4fr 3fr 1fr 0.7fr 0.5fr 1fr 0.5fr 1fr 1fr;
  text-align: end;
  font-style: italic;
}

.cgst .grid-item {
  border-right: 1px solid black;
}

.sgst {
  grid-template-columns: 0.4fr 3fr 1fr 0.7fr 0.5fr 1fr 0.5fr 1fr 1fr;
  text-align: end;
  font-style: italic;
}

.sgst .grid-item {
  border-right: 1px solid black;
}

.round-off {
  grid-template-columns: 0.4fr 3fr 1fr 0.7fr 0.5fr 1fr 0.5fr 1fr 1fr;
  text-align: end;
  font-style: italic;
}

.round-off .grid-item {
  border-right: 1px solid black;
}

.total .grid-item {
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  border-top: 1px solid black;
}

.bottom-border {
  border-bottom: 1px solid black;
}

.product-list {
  grid-template-columns: 0.4fr 3fr 1fr 0.7fr 0.5fr 1fr 0.5fr 1fr 1fr;
}

.header-column-products .grid-item {
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}

.header-column-products .grid-item:last-child {
  border-right: none;
}

.product-list .grid-item {
  border-right: 1px solid black;
  min-height: 25px;
  padding-bottom: 0px;
  max-height: 25px;
}

.product-list .grid-item:last-child {
  border-right: none;
}

.grid-row.note {
  grid-template-columns: 50% 50%;
}

.second-note {
  text-align: right;
}

.gst-details {
  align-items: flex-end;
  display: flex;
  height: 100%;
}

.grid-row .last-row {
  grid-template-columns: 50% 50%;
}

.last-row .signature {
  display: flex;
  height: 100%;
  border-top: 1px solid black;
  border-left: 1px solid black;
}

.last-row .declaration {
  padding: 5px;
}

.company-details .grid-item {
  display: grid;
  grid-template-columns: 42% 58%;
  padding: 0;
}

.company-details .grid-item span:last-child {
  font-weight: bold;
}
.amount-in-words {
  padding-top: none;
  font-weight: bold;
}

.grid-item .meta {
  display: grid;
  border-bottom: 1px solid black;
  padding-left: 5px;
}

.grid-item .meta:last-child {
  border-bottom: none;
}
</style>
